import React from "react";
import { cn } from "./cn";
import Checkbox from "./Checkbox";

/**
 * Bun task row. Spec: components/data/TaskRow. Checkbox + title + right meta
 * (due text, assignee avatar); done strikes through in faint. Compose inside
 * a Card; rows separate themselves with line-soft.
 */
export default function TaskRow({ done, onToggle, title, meta, className }) {
  return (
    <div
      className={cn(
        "flex items-center gap-[10px] px-3 py-[10px] font-instrument",
        "border-b border-bun-line-soft last:border-b-0",
        className
      )}
    >
      <Checkbox checked={!!done} onChange={(e) => onToggle && onToggle(e.target.checked)} />
      <div
        className={cn(
          "flex-1 min-w-0 truncate text-bun-body font-book",
          done ? "text-bun-faint line-through" : "text-bun-text"
        )}
      >
        {title}
      </div>
      {meta}
    </div>
  );
}
